"use client";

import React from "react";

const inputStyle: React.CSSProperties = {
  width: "100%",
  border: "1px solid #e5e7eb",
  borderRadius: 12,
  padding: "10px 10px",
  fontSize: 14,
  outline: "none",
  background: "#ffffff",
  color: "#111827",
};

type Props = {
  inboxEmail: string;
  formAction: string; // empty string = mailto fallback
  inquiryTypes: readonly string[];
};

export default function ContactForm({ inboxEmail, formAction, inquiryTypes }: Props) {
  return (
    <form
      method="POST"
      action={formAction || undefined}
      onSubmit={(e) => {
        if (!formAction) {
          e.preventDefault();

          const form = e.currentTarget as HTMLFormElement;
          const fd = new FormData(form);
          const name = String(fd.get("name") || "");
          const org = String(fd.get("org") || "");
          const email = String(fd.get("email") || "");
          const type = String(fd.get("type") || "");
          const message = String(fd.get("message") || "");

          const subject = encodeURIComponent(`VP Inquiry: ${type} — ${name}${org ? ` (${org})` : ""}`);
          const body = encodeURIComponent(
            `Name: ${name}\nOrganization: ${org}\nEmail: ${email}\nInquiry Type: ${type}\n\nMessage:\n${message}\n`
          );

          window.location.href = `mailto:${inboxEmail}?subject=${subject}&body=${body}`;
        }
      }}
      style={{ display: "grid", gap: 10 }}
    >
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <label style={{ display: "grid", gap: 6, fontSize: 13, color: "#111827", fontWeight: 700 }}>
          Name
          <input name="name" required style={inputStyle} placeholder="Your name" />
        </label>

        <label style={{ display: "grid", gap: 6, fontSize: 13, color: "#111827", fontWeight: 700 }}>
          Organization
          <input name="org" style={inputStyle} placeholder="Company / institution (optional)" />
        </label>
      </div>

      <label style={{ display: "grid", gap: 6, fontSize: 13, color: "#111827", fontWeight: 700 }}>
        Email
        <input name="email" type="email" required style={inputStyle} placeholder="you@domain.com" />
      </label>

      <label style={{ display: "grid", gap: 6, fontSize: 13, color: "#111827", fontWeight: 700 }}>
        Inquiry type
        <select name="type" required style={inputStyle as any} defaultValue={inquiryTypes[0]}>
          {inquiryTypes.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </label>

      <label style={{ display: "grid", gap: 6, fontSize: 13, color: "#111827", fontWeight: 700 }}>
        Message
        <textarea
          name="message"
          required
          rows={7}
          style={{ ...inputStyle, resize: "vertical" }}
          placeholder="Write your message with enough context to route it correctly."
        />
      </label>

      <button
        type="submit"
        style={{
          marginTop: 4,
          padding: "10px 12px",
          borderRadius: 12,
          border: "1px solid #111827",
          background: "#111827",
          color: "#ffffff",
          fontWeight: 800,
          cursor: "pointer",
        }}
      >
        Submit inquiry
      </button>

      {!formAction && (
        <p style={{ margin: "8px 0 0", fontSize: 12, color: "#6b7280" }}>
          This form is currently routed via email (mailto). If you want server-side capture, set <code>FORM_ACTION</code>.
        </p>
      )}
    </form>
  );
}
